<template>
  <div>
    <el-button type="text" @click="dialogFormVisible = true"
      >修改公式</el-button
    >
    <el-dialog
      title="修改公式"
      :modal="false"
      :visible.sync="dialogFormVisible"
    >
      <el-form :model="formula">
        <el-input v-model="formula.key" autocomplete="off"></el-input>
      </el-form>
      <p>JD津贴公式</p>
      <el-form :model="formula2">
        <el-input v-model="formula2.key" autocomplete="off"></el-input>
      </el-form>
      <p></p>
      <el-tag type="danger"
        >公式输入提示：新机价格为x，旧机价格为y，故障类型为z，如：x*0.1 + y *
        0.2 - z</el-tag
      >
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="updateConfig">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { sysConfigUpdate, getSysConfigById } from "@/api/system";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      dialogFormVisible: false,
      configInfo: {
        id: 20,
        name: "",
        key: "",
      },
      configInfo2: {
        id: 21,
        name: "",
        key: "",
      },
    };
  },
  computed: {
    ...mapGetters(["formula", "formula2"]),
  },
  methods: {
    async updateConfig() {
      const res = await sysConfigUpdate(this.formula);
      const res2 = await sysConfigUpdate(this.formula2);
      console.log(res,res2)
      if (res.data.code == 200 && res2.data.code == 200) {
        this.$message.success("修改成功");
        this.dialogFormVisible = false;
        this.$store.dispatch("setFormula");
      }
    },
  },
};
</script>

<style>
</style>